import type { ComputedRef, Ref } from 'vue';
import { pick } from 'lodash-es';
import {
  computed,

} from 'vue';

import type { IGroupOptions } from '@modules/reports/types';
import { useGroupBySelectOptions } from '@modules/reports/composables';
import { EGroupNames } from '@modules/reports/types';

import type { IGroupByParamsEmits, IGroupSelectOptions, IGroupSelectValues } from '../types';

export interface GroupByParamsComposable {
  groups: ComputedRef<Partial<IGroupSelectOptions<IGroupOptions>>>;
  onChange(key: keyof IGroupSelectValues, val: string): void;
}

export default function useGroupByParams(
  groupOptions: Ref<IGroupOptions | undefined>,
  availableGroups: Ref<EGroupNames[] | undefined>,
  translationKey: Ref<symbol>,
  emit: IGroupByParamsEmits,
): GroupByParamsComposable {
  const SHORTCODE_PART = 'REPORTS.GROUP_BY.';

  const { buildList } = useGroupBySelectOptions();

  const options = computed<IGroupSelectOptions>(() => ({
    [EGroupNames.DATE]: buildList(groupOptions.value?.[EGroupNames.DATE], translationKey.value, `${SHORTCODE_PART}%s`),
    [EGroupNames.AFFILIATE]: buildList(groupOptions.value?.[EGroupNames.AFFILIATE], translationKey.value, `${SHORTCODE_PART}%s`),
    [EGroupNames.PLAYER]: buildList(groupOptions.value?.[EGroupNames.PLAYER], translationKey.value, `${SHORTCODE_PART}%s`),
    [EGroupNames.ROW_ON_PAGE]: buildList(groupOptions.value?.[EGroupNames.ROW_ON_PAGE], translationKey.value, `${SHORTCODE_PART}rows_per_page`, true),
  }));

  const groups = computed<Partial<IGroupSelectOptions>>(() => {
    if (!availableGroups.value) {
      return options.value;
    }
    return pick(options.value, availableGroups.value);
  });

  function onChange(key: keyof IGroupSelectValues, val: string): void {
    emit('change', key, val);
  }

  return {
    groups,
    onChange,
  };
}
